module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 41300.6ef9ed6b.png";